import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as paymentMonthRunsState from '../reducers';
import * as paymentMonthRunsReducer from '../reducers/payment-run-months.reducer';

export const selectPaymentMonthRuns = createSelector(
  paymentMonthRunsState.selectPaymentRunMonthsState,
  paymentMonthRunsReducer.getPaymentRunMonths
);

export const selectPaymentMonthRunsIsLoaded = createSelector(
  paymentMonthRunsState.selectPaymentRunMonthsState,
  paymentMonthRunsReducer.getPaymentRunMonthsIsLoaded
);
